import { EditorialHubContent } from "@/features/editorial-hub/editorial-hub-content";
import { Route } from "/app/apps/web/src/routes/_app/$lang/editorial/index.tsx";
function EditorialHubRoute() {
  const {
    locale
  } = Route.useLoaderData();
  return <EditorialHubContent locale={locale} />;
}
export { EditorialHubRoute as component };